import { FormData } from "../types";

import {
  ViewOffSlashIcon,
  ToggleOffIcon,
  Notification01Icon,
  PlazaIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { getFullName } from "shared/utils/get-full-name";
import { Applicant } from "types/application";
import { getApplicantRole } from "utils/getApplicantRole";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { ActionSuccessCard } from "../components/ActionSuccessCard";
import { useAuthContext } from "providers/Auth";

export const SuccessView = ({
  formData,
  address,
  applicants
}: {
  formData: FormData;
  address: string;
  applicants: Applicant[];
}) => {
  const dictionary = useUnitsPropertiesDictionary();
  const { type } = useAuthContext();

  return (
    <div className="p-6 bg-background-900 min-h-full space-y-4 px-14">
      {formData.unlistUnit ? (
        <ActionSuccessCard
          icon={ViewOffSlashIcon}
          title={`${dictionary.Unit} unlisted`}
        >
          <p className="text-sm font-medium text-content-1000">
            {dictionary.Unit} {address} unlisted from the{" "}
            {type.isBoomCRM ? "listing page" : "portfolio page"}
          </p>
        </ActionSuccessCard>
      ) : null}

      {formData.disallowApplications ? (
        <ActionSuccessCard
          icon={ToggleOffIcon}
          title={`Applying disallowed for ${dictionary.unit}`}
        >
          <p className="text-sm font-medium text-content-1000">
            Acceptance of new applications for {dictionary.Unit}{" "}
            {address.split(",")[0]} at {address.split(",").slice(1).join(",")},
            has been paused
          </p>
        </ActionSuccessCard>
      ) : null}

      {formData.sendNotifications ? (
        <ActionSuccessCard
          icon={Notification01Icon}
          title="Email about decision have been sent"
        >
          <div className="space-y-4">
            {applicants.map((applicant) => (
              <div
                key={applicant.id}
                className="text-sm font-medium text-content-1000"
              >
                {getFullName({
                  firstName: applicant.first_name,
                  lastName: applicant.last_name,
                  middleName: applicant.middle_name,
                  short: true
                })}
                ,{" "}
                <span className="text-content-400">
                  {getApplicantRole(applicant.role)}
                </span>
              </div>
            ))}
          </div>
        </ActionSuccessCard>
      ) : null}

      {formData.addApplicantsToPMS ? (
        <ActionSuccessCard
          icon={PlazaIcon}
          title="Prospects have been created in your Property Management Software"
          className="px-6 mb-4"
        />
      ) : null}
    </div>
  );
};
